import styled from "styled-components";

const PanelWrapper = styled.div`
	margin-bottom: 16px;
`;

export { PanelWrapper };
